import React, { useState } from "react";
import { MenuList } from "./Menulist";
import "./Navbar1.css";
import { Link } from "react-router-dom";

function Navbar1() {
  const [clicked, setClicked] = useState(false);

  // console.log("menulist");
  const menuList = MenuList.map(({ url, title }, index) => {
    return (
      <li key={index}>
        {/* activeclassName="active" -----------this can bre add on link tag */}
        <Link exact="true" to={url}>
          {title}
        </Link>
      </li>
    );
  });

  const handleClick = () => {
    // console.log("clicked");
    setClicked(!clicked);
  };

  return (
    <nav>
      <div className="logo">
        <p>
          {" "}
          <span className="font">Pijush</span>
        </p>
      </div>
      <div className="menu-icon" onClick={handleClick}>
        {/* <i className={clicked ? "fas fa-times" : "fas fa-bars"}></i> */}
      </div>
      <ul className={clicked ? "menu-list" : "menu-list close "}>{menuList}</ul>
    </nav>
  );
}

export default Navbar1;
